<template>
	<div class="marketing-input-container">
		<label :class="['marketing-label', labelClass]">
			Frequency
		</label>
		<Multiselect
			mode="tags"
			class="marketing-select"
			:options="weekDays"
			:modelValue="sortedDays"
			@select="valueSelected"
			@deselect="valueDeselected"
			@keypress.ctrl="escapeBug"
		/>
	</div>
</template>

<script>
	import Multiselect from '@vueform/multiselect';
	import weekDays from '@/constants/weekDays';

	export default {
		name: 'MarketingWeekDaySelect',
		components: { Multiselect },
		props: ['label', 'labelClass', 'modelValue'],
		data: () => ({
			weekDays: weekDays,
		}),
		computed: {
			sortedDays() {
				// return this.modelValue
				// 	.map((option) => {
				// 		return this.weekDays.find((day) => day.value === option);
				// 	})
				// 	.sort((a, b) => b - a.index)
				// 	.map((weekDay) => weekDay.value);
				return this.modelValue ? this.modelValue.match(/[A-Z][a-z]+/g) : [];
			},
		},
		methods: {
			escapeBug(e) {
				console.log(e);
			},
			valueSelected(e) {
				let newVal = `${this.modelValue || ''}${e}`;
				this.$emit('update:modelValue', newVal);
			},
			valueDeselected(e) {
				let newVal = this.modelValue.replace(e, '');
				this.$emit('update:modelValue', newVal);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.marketing-input-container {
		@apply w-full flex flex-col mr-3 mb-2;

		.marketing-label {
			@apply text-13 font-semibold mr-2;
			min-width: 36px;
		}

		.marketing-select {
			@apply w-full;
			:deep(.multiselect-input) {
				@apply p-2 border-1 border-border-color rounded-default bg-white w-full;
			}
		}
	}
</style>
